import React from 'react';
import { useAppContext } from '../contexts/AppContext';
import '../style.css';
import { loaderGIF } from '../assets/superAdminAssets';

const Loader = () => {
    const { isLoading } = useAppContext();

    if (!isLoading) return null;

    return (
        <div className="preloader">
            {/* Loader Image */}
            <div className='loader-box'>
                <img className='loader-obj' src={loaderGIF} alt="Loading..." />
                <h4>Loading... Just a moment!</h4>
            </div>
        </div>
    );
};

export default Loader;
